// removed by extract-text-webpack-plugin
module.exports = {"SkillList":"SkillList__SkillList__39Q4H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Builder/SkillList/SkillList.css
// module id = 145
// module chunks = 0